import { Button } from "@nook/ui"
import { Link } from "@tanstack/react-router"
import { Search } from "lucide-react"

import { useOverlay } from "@/components/app-shell.js"
import { EmptyState } from "@/components/empty-state.js"
import { Keys } from "@/components/keys.js"

/** Any URL the router does not know, inside the app rather than a bare "Not Found". */
export function NotFound() {
  const overlay = useOverlay()
  return (
    <EmptyState
      art={<p aria-hidden className="text-muted-foreground/40 text-7xl font-semibold tracking-tighter">404</p>}
      title="This page doesn't exist"
      description="The link may be old, or mistyped. What you were after may still be in your library."
      action={
        <div className="flex flex-wrap justify-center gap-2">
          <Button asChild>
            <Link to="/">Back to Library</Link>
          </Button>
          <Button variant="outline" onClick={() => overlay("palette")}>
            <Search />
            Search your nooks
            <Keys keys="$mod+k" />
          </Button>
        </div>
      }
    />
  )
}
